<template>
 <div>
    <el-radio-group @change="dateTabChange" v-if="isShowDateTab" v-model="dateActive" style="margin-bottom: 16px;">
      <el-radio-button label="day">日分析</el-radio-button>
      <el-radio-button label="week">周分析</el-radio-button>
      <el-radio-button label="month">月分析</el-radio-button>
    </el-radio-group>
    <div class="filter-data">
      <span class="filter-text">选择时间</span>
      <div class="filter-control">
        <el-date-picker
          v-show="dateActive=='day'"
          v-model="formData.searchDate"
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          @change="dateChange"
          :picker-options="pickerOptions"
          placeholder="请选择日期时间">
        </el-date-picker>
        <!-- eslint-disable vue/no-unused-refs -->
        <el-date-picker
          v-show="dateActive=='week'"
          ref="weekRef"
          v-model="formData.weekValue"
          type="week"
          format="yyyy 第 WW 周"
          :picker-options="{
            firstDayOfWeek: 1,
            ...pickerOptions
          }"
          @change="dateChange"
          placeholder="选择周">
        </el-date-picker>
        <el-date-picker
          v-show="dateActive=='month'"
          v-model="formData.monthValue"
          type="month"
          @change="dateChange"
          :picker-options="pickerOptions"
          value-format="yyyy-MM"
          placeholder="选择月">
        </el-date-picker>
        <el-button :loading="btnLoading" @click="search"  type="primary">搜索</el-button>
        <el-button @click="reset">重置</el-button>
        <export
          :exportTemplate="exportTemplate"
          :filename="fileName"
          :isShowIcon="true"
          :params="formData"
        />
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'

const now = moment().format('YYYY-MM-DD') || ''
export default {
  components: {
  },
  props: {
    isShowDateTab: {
      type: Boolean,
      default: false,
    },
    exportTemplate: {
      type: String,
      default: '',
    },
    filename: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dateActive: 'day',
      btnLoading: false,
      formData: {
        weekValue: '',
        monthValue: '',
        startDate: now,
        endDate: now,
        searchDate: now,
        searchType: 1, // 1：日、2：周、3：月
      },
      exportParams: {
        searchType: 1,
      },
      // 天时间范围
      pickerOptions: {
        disabledDate: (date) => {
          let condition = Date.now()
          if (this.dateActive === 'week') {
            condition = moment().weekday(7).valueOf()
          }
          if (this.dateActive === 'month') {
            condition = moment().endOf('month').valueOf()
          }
          return date.getTime() > condition
        },
      },
    }
  },
  computed: {
    // 导出文件名+时间
    fileName() {
      const { searchDate, startDate, endDate } = this.formData
      if (searchDate) {
        return `${this.filename + searchDate}.xlsx`
      } else if (startDate || endDate) {
        return `${this.filename + startDate},${endDate}.xlsx`
      }
      return `${this.filename}.xlsx`
    },
  },
  mounted() {
    this.search()
  },
  created() {
    this.dateChange(this.formData.searchDate)
  },
  methods: {
    search() {
      this.btnLoading = true
      this.$emit('search', this.formData, () => { this.btnLoading = false })
    },
    // 重置
    reset(isSearch = true) {
      for (const key in this.formData) {
        if (this.formData[key]) {
          this.formData[key] = ''
        }
      }
      this.initSearchDate()
      isSearch && this.search()
    },
    // 选择时间
    dateChange(val) {
      this.formData.startDate = val ? this.setDateParams(val).startDate : ''
      this.formData.endDate = val ? this.setDateParams(val).endDate : ''
      const dateStr = this.setDateNum(this.formData.startDate, this.formData.endDate)
      this.$emit('dateChange', this.formData, dateStr)
    },
    // 格式化时间
    setDateParams(val) {
      const obj = {
        startDate: '',
        endDate: '',
      }
      // 获取今天的日期
      const today = moment().format('YYYY-MM-DD')
      if (this.dateActive === 'week') {
        obj.startDate = moment(val).startOf('week').add(1, 'days').format('YYYY-MM-DD')
        obj.endDate = moment(val).endOf('week').add(1, 'days').format('YYYY-MM-DD')
      } else {
        obj.startDate = moment(moment(val).startOf(this.dateActive)).format('YYYY-MM-DD')
        obj.endDate = moment(moment(val).endOf(this.dateActive)).format('YYYY-MM-DD')
      }
      obj.endDate = obj.endDate > today ? today : obj.endDate
      return obj
    },
    // 日、周、月分析切换
    dateTabChange(val) {
      this.reset(false)
      const dateEnum = {
        day: 1,
        week: 2,
        month: 3,
      }
      this.formData.searchType = dateEnum[val]
      this.exportParams.searchType = dateEnum[val]

      this.initSearchDate(val)
      this.$emit('dateTabChange', this.formData)
      this.search()
    },
    // 转时间戳
    setDateNum(a, b) {
      const start = moment(`${a} 00:00:00`).unix() * 1000 || ''
      const end = moment(`${b} 23:59:59`).unix() * 1000 || ''
      return (start && end) ? `${start}_${end}` : ''
    },
    // 初始化日期
    initSearchDate(val) {
      const { dateActive, isShowDateTab } = this
      const filterType = val || dateActive
      const todayMonth = moment().format('YYYY-MM') || ''
      const today = moment().format('YYYY-MM-DD') || ''
      if (filterType === 'week') {
        this.formData.weekValue = moment() || ''
      } else if (filterType === 'month') {
        this.formData.monthValue = todayMonth
      } else {
        // val：tab切换（day），isShowDateTab展示日周月分析； 如果是非重置（tab切换）&&展示日周月分析tab；其他场景会清空选择时间
        // eslint-disable-next-line no-lonely-if
        if (val || isShowDateTab) this.formData.searchDate = today
      }
      this.dateChange(today)
    },
  },
}
</script>
<style scoped lang='scss'>
.filter-data{
  padding: 16px;
  background: #F7F8FA;
  border: 1px dashed #DCDFE6;
  border-radius: 8px;
  margin-bottom: 24px;
  .filter-text{
    font-size: 12px;
    color: #606266;
    display: inline-block;
    margin-bottom: 2px;
  }
  .export-btn{
    display: inline-block;
    margin-left: 8px;
  }
}
</style>
